
import { store } from '@/store'
import { defineComponent, reactive } from 'vue'

export default defineComponent({
  name: 'RouteStats',
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  setup(props) {

    const state = reactive({
      loading: false
    })

    const subscription = store.user.get(state => state.subscription)

    async function goLive() {
      state.loading = true
      await store.route.goLive(props.route.id)
      state.loading = false
    }
    return { state, store, subscription, goLive }
  }
})
